<template>
  <div class="list-wrapper">
    <div>Contact</div>
  </div>
</template>

<style scoped></style>
